import { NewPasswordSettingForm } from "@/features/authenticate/components/newPasswordSettingForm";
import { Container, Stack } from "@mantine/core";

export const ForgetPasswordResetPage = () => {
	return (
		<Container
			size="xl"
			style={{
				height: "100vh",
			}}
		>
			<Stack align="center" justify="center" h="100%">
				<NewPasswordSettingForm
					// TODO: 本実装
					handleSubmit={() => {
						return Promise.resolve();
					}}
				/>
			</Stack>
		</Container>
	);
};
